/* START POLYFILLS */
import 'whatwg-fetch';
import 'promise-polyfill/dist/polyfill';
import 'intersection-observer';
import './array-from';
/* END POLYFILLS */
import 'siema/dist/siema.min';
import 'vanilla-lazyload/dist/lazyload.min';



// WEBPACK FOOTER //
// ./src/rcs-orchestrator/libs/index.js